import { useEffect, useState } from 'react'

/**
 * Puts the Bridge theme (index.css `html.theme-bridge`) on <html> while the
 * calling page is mounted. On <html> rather than a wrapper div so popovers and
 * modals portalled to <body> pick it up too.
 */
export function useBridgeTheme() {
  useEffect(() => {
    const root = document.documentElement
    root.classList.add('theme-bridge')
    return () => root.classList.remove('theme-bridge')
  }, [])
}

/**
 * Light/dark for Transit, kept in this browser only (localStorage.theme, which
 * main.tsx reads at startup). Not ThemeToggle: that also saves the choice to
 * the signed-in Django account, and Transit users have none.
 */
export function useColorMode() {
  const [dark, setDark] = useState(() => document.documentElement.classList.contains('dark'))
  const toggle = () => {
    // Read the page, not state: UserProvider may have set it since mount.
    const next = !document.documentElement.classList.contains('dark')
    document.documentElement.classList.toggle('dark', next)
    try {
      localStorage.setItem('theme', next ? 'dark' : 'light')
    } catch {
      // Storage blocked: the switch still holds for this page.
    }
    setDark(next)
  }
  return { dark, toggle }
}
